import React, { useEffect, useState } from 'react'
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import BtnSpinner from '../../components/BtnSpinner';
import { Save, X } from 'lucide-react';

function AddOrEditCoupon({ coupon, close, setRefresh }) {

    const [formData, setFormData] = useState({
        coupon_code: "",
        coupon_title: "",
        status: "",
        discount_percentage: "",
        expiry_date: "",
        include_courses: []
    });

    const [loading, setLoading] = useState({ state: false, name: "" });
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const token = localStorage.getItem('token');
    const [courses, setCourses] = useState(null);
    const [edit, setEdit] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleCourseChange = (course) => {
        const { _id, course_title } = course;
        const isSelected = formData.include_courses.includes(_id);

        if (isSelected) {
            setFormData({
                ...formData,
                include_courses: formData.include_courses.filter(courseId => courseId !== _id)
            });
            setSelectedCourses(selectedCourses.filter(courseTitle => courseTitle !== course_title));
        } else {
            setFormData({
                ...formData,
                include_courses: [...formData.include_courses, _id]
            });
            setSelectedCourses([...selectedCourses, course_title]);
        }
    };

    const fetchCourses = async () => {

        setLoading({ state: true, name: "getcourses" });

        try {
            const response = await Apirequests('courses/get-courses', 'GET', {}, {
                Authorization: `Bearer ${token}`,
            });

            console.log(response, 'ress')

            if (response.success) {
                setCourses(response.data);
            } else {
                setCourses([])
            }
        } catch (error) {
            setCourses([]);
            console.log(error, 'get courses error')
        }
        setLoading({ state: false, name: "" })
    }

    const handleAddCoupon = async (e) => {
        e.preventDefault();

        if (!formData.coupon_code || !formData.coupon_title || !formData.discount_percentage || !formData.expiry_date || !formData.include_courses.length) {
            return ErrorTost('Please Enter all fields.')
        };
        setLoading({ state: true, name: "addcoupon" })
        try {
            const res = await Apirequests('coupons/create-coupon', 'POST', formData, {
                Authorization: `Bearer ${token}`,
            });
            console.log(res, 'response');
            if (res.success) {
                SuccessTost(res.message);
                close();
                setRefresh((prev) => !prev)
            } else {
                ErrorTost(res.message)
            }
        } catch (error) {
            console.log(error, 'post coupon error');
            ErrorTost("Something went wrong, please try again later")
        }
        setLoading({ state: false, name: "" })
    };

    const handleUpDateCoupon = async (e) => {
        e.preventDefault();
        if (
            !formData.coupon_code ||
            !formData.coupon_title ||
            !formData.discount_percentage ||
            !formData.expiry_date ||
            !formData.include_courses.length
        ) {
            return ErrorTost("Please enter all fields.");
        }
        setLoading({ status: true, name: "updatecoupon" });
        try {
            const res = await Apirequests(
                `coupons/edit-coupon/${coupon?._id}`,
                "PUT",
                formData,
                {
                    Authorization: `Bearer ${token}`,
                }
            );
            console.log(res,'response edit')
            if (res.success) {
                SuccessTost(res.message);
                setRefresh((prev) => !prev);
                close();
            } else {
                ErrorTost(res.message);
            }
        } catch (error) {
            console.error("Error updating coupon:", error);
            ErrorTost("An error occurred while updating the coupon");
        }
        setLoading({ status: false, name: "" });

        // console.log(formData,'formData')
    };

    const handleSubmit=async(e)=>{
        console.log(coupon,'cpn')
        if(coupon){
            await handleUpDateCoupon(e)
        }else{
            await handleAddCoupon(e)
        }
    }

    useEffect(() => {
        fetchCourses()
    }, [])

    useEffect(() => {
        if (coupon) {

            const ids = coupon?.include_courses?.map((c, i) => c?._id);

            setFormData({
                coupon_code: coupon?.coupon_code,
                coupon_title: coupon?.coupon_title,
                status: coupon?.status,
                discount_percentage: coupon?.discount_percentage,
                expiry_date: new Date(coupon.expiry_date).toISOString().split("T")[0],
                include_courses: ids || []
            });

            // Update selected courses array for UI checkbox
            const selectedTitles = courses
                ?.filter(course => ids.includes(course._id))
                .map(course => course.course_title);
            setSelectedCourses(selectedTitles || []);

            setEdit(true);
        };

        return () => {
            setFormData({
                coupon_code: "",
                coupon_title: "",
                status: "",
                discount_percentage: "",
                expiry_date: "",
                include_courses: []
            });
            setSelectedCourses([]);
            setEdit(false)
        }
    }, [coupon, courses]);

    console.log(selectedCourses,'selected courses')

    return (
        <div>
            <h1 className="text-2xl font-bold mb-4 text-center">{edit ? "Edit Coupon" : "Add Coupon"}</h1>
            <form onSubmit={handleSubmit}>
                <div className='my-3'>
                    <label className="block text-sm font-medium text-gray-700">Coupon Code</label>
                    <input type="text" name="coupon_code" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" value={formData.coupon_code} onChange={handleChange} />
                </div>
                <div className='my-3'>
                    <label className="block text-sm font-medium text-gray-700">Coupon Title</label>
                    <input type="text" name="coupon_title" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" value={formData.coupon_title} onChange={handleChange} />
                </div>
                <div className='my-3'>
                    <label className="block text-sm font-medium text-gray-700">Discount Percentage</label>
                    <input type="number" name="discount_percentage" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" value={formData.discount_percentage} onChange={handleChange} />
                </div>
                <div className='my-3'>
                    <label className="block text-sm font-medium text-gray-700">Status</label>
                    <select name="status" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" onChange={handleChange} value={formData?.status}>
                        <option value="">Please select status</option>
                        <option value="Active">Active</option>
                        <option value="Disabled">Disabled</option>
                    </select>
                </div>
                <div className='my-3'>
                    <label className="block text-sm font-medium text-gray-700">Expiry Date</label>
                    <input type="date" name="expiry_date" value={formData?.expiry_date} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" onChange={handleChange} />
                </div>

                {/* Custom Select Dropdown with Checkboxes */}
                <div className='my-3'>
                    <label className="block text-sm font-medium text-gray-700">Include Courses</label>
                    <div className="relative">
                        {/* Custom Select Tag */}
                        <div className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm cursor-pointer focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" onClick={toggleDropdown}>
                            {selectedCourses.length > 0 ? selectedCourses.join(', ') : 'Please select courses'}
                        </div>

                        {dropdownOpen && (
                            <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg">
                                <ul className="max-h-60 overflow-y-auto py-1 text-gray-700">
                                    {courses.map((course) => (
                                        <li key={course._id} className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => handleCourseChange(course)}>
                                            <input
                                                type="checkbox"
                                                checked={formData.include_courses.includes(course._id)}
                                                onChange={() => handleCourseChange(course)}
                                                className="mr-2"
                                            />
                                            {course.course_title}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>

                <div className="flex gap-4">
                        {edit ? <button
                            type="submit"
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                        >
                            {
                                loading.state && loading.name === "updatechapter" ?
                                    <BtnSpinner /> :
                                    <>
                                        <Save className="w-5 h-5" />
                                        <span className='text-white'>Update Coupon</span>
                                    </>
                            }

                        </button>
                            :
                            <button
                                type="submit"
                                className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                            >
                                {
                                    loading.state && loading.name === "addcoupon" ?
                                        <BtnSpinner /> :
                                        <>
                                            <Save className="w-5 h-5" />
                                            <span className='text-white'>Create Coupon</span>
                                        </>
                                }

                            </button>}
                        <button
                            type="button"
                            onClick={()=>close()}
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
                        >
                            <X className="w-5 h-5" />
                            Cancel
                        </button>
                    </div>
            </form>
        </div>
    )
}

export default AddOrEditCoupon